import { forwardRef } from 'react';
import TextField from '@mui/material/TextField';
import customTwMerge from 'utils/twMerge';
import { IOutlinedInput } from 'types/molecules';

const COutlinedInput = forwardRef<HTMLDivElement, IOutlinedInput>(
  ({ InputProps, InputLabelProps, borderless, ...rest }, ref) => {
    const inputHeight = {
      medium: {
        label: { root: 'top-[-4px]', shrink: '!top-[0]' },
        input: 'py-[12.5px]',
      },
    };

    const customProps = {
      InputLabelProps: {
        ...InputLabelProps,
        classes: {
          root: customTwMerge(
            'border-primary-300 [&.Mui-error]:border-danger text-body16 text-neutral-300',
            inputHeight.medium.label.root,
            InputLabelProps?.classes?.root
          ),
          focused: customTwMerge('!text-primary-500', InputLabelProps?.classes?.focused),
          asterisk: customTwMerge(
            '[.MuiInputLabel-shrink_&]:text-danger',
            InputLabelProps?.classes?.asterisk
          ),
          shrink: customTwMerge(inputHeight.medium.label.shrink, InputLabelProps?.classes?.shrink),
        },
      },
      InputProps: {
        ...InputProps,
        classes: {
          root: customTwMerge('group/input rounded-xl', InputProps?.classes?.root),
          input: customTwMerge(
            'text-label16 text-neutral-500 truncate',
            inputHeight.medium.input,
            InputProps?.classes?.input
          ),
          notchedOutline: customTwMerge(
            'rounded-xl border-neutral-border group-hover/input:border-primary-300 [.Mui-focused_&]:!border-primary-400 [.Mui-error_&]:!border-danger',
            borderless && 'border-none',
            InputProps?.classes?.notchedOutline
          ),
          disabled: customTwMerge('rounded-xl bg-disabled', InputProps?.classes?.disabled),
        },
      },
    };

    return (
      <TextField
        {...rest}
        ref={ref}
        data-sentry-mask
        InputLabelProps={customProps.InputLabelProps}
        InputProps={customProps.InputProps}
        variant="outlined"
      />
    );
  }
);

export default COutlinedInput;
